/*
 * House of Daisy — an approximate price in the visitor's own currency
 * (owner, 2026-10-14). The store charges in rupees only (no Shopify Payments
 * in India), so this is a reading aid: under a rupee price, a visitor from a
 * country we ship to sees "about US$1,790", and on the product page and in
 * the bag "· you pay in ₹ at checkout". Visitors in India see nothing new.
 *
 * Country: Shopify's own (the market it placed the visitor in); if that says
 * India, Shopify's browsing-context suggestion is asked once per session.
 * Rates: the European Central Bank's daily reference rates (frankfurter.dev),
 * kept for 12 hours. Gulf currencies are pegged to the US dollar, so they are
 * worked out from the USD rate at their official pegs. Where neither exists,
 * the price shows in US dollars.
 */
(function () {
  var script = document.currentScript;
  if (!script || window.hodFx) return;
  window.hodFx = true;

  var EURO = 'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK'.split(' ');
  var DIRECT = { US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', NZ: 'NZD', SG: 'SGD', MY: 'MYR', ZA: 'ZAR', CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN', CZ: 'CZK', HU: 'HUF', RO: 'RON', BG: 'BGN', HK: 'HKD', JP: 'JPY' };
  // Official pegs to the US dollar (units of local currency per USD).
  var PEG = { AE: ['AED', 3.6725], SA: ['SAR', 3.75], QA: ['QAR', 3.64], OM: ['OMR', 0.3845], BH: ['BHD', 0.376] };

  var allowed = (script.dataset.countries || '').split(',');
  var aboutText = script.dataset.about || 'about [amount]';
  var noteText = script.dataset.note || 'you pay in ₹ at checkout';

  function store(kind, key, value) {
    try {
      if (value === undefined) return JSON.parse(window[kind].getItem(key) || 'null');
      window[kind].setItem(key, JSON.stringify(value));
    } catch (e) {
      return null;
    }
  }

  function detectCountry() {
    // ?hod_fx=US previews the line as a visitor from that country would see it.
    var forced = new URLSearchParams(location.search).get('hod_fx');
    if (forced) return Promise.resolve(forced.toUpperCase());
    var liquid = (script.dataset.country || '').toUpperCase();
    if (liquid && liquid !== 'IN') return Promise.resolve(liquid);
    var cached = store('sessionStorage', 'hodFxCountry');
    if (cached) return Promise.resolve(cached);
    return fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var c = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || 'IN';
        c = String(c).toUpperCase();
        store('sessionStorage', 'hodFxCountry', c);
        return c;
      })
      .catch(function () { return 'IN'; });
  }

  function currencyFor(country) {
    if (EURO.indexOf(country) > -1) return { code: 'EUR' };
    if (DIRECT[country]) return { code: DIRECT[country] };
    if (PEG[country]) return { code: PEG[country][0], viaUsd: PEG[country][1] };
    return { code: 'USD' };
  }

  function rateFor(cur) {
    var base = cur.viaUsd ? 'USD' : cur.code;
    var key = 'hodFxRate-' + base;
    var cached = store('localStorage', key);
    var fresh = cached && Date.now() - cached.at < 12 * 3600 * 1000;
    var got = fresh
      ? Promise.resolve(cached.rate)
      : fetch('https://api.frankfurter.dev/v1/latest?from=INR&to=' + base)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var rate = j && j.rates && j.rates[base];
            if (rate) store('localStorage', key, { rate: rate, at: Date.now() });
            return rate || null;
          })
          .catch(function () { return null; });
    return got.then(function (rate) { return rate && cur.viaUsd ? rate * cur.viaUsd : rate; });
  }

  function rupees(el) {
    var text = (el.textContent || '').replace(/,/g, '');
    var m = text.match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }

  function start(cur, rate) {
    var fmt;
    try {
      fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cur.code, maximumFractionDigits: cur.code === 'OMR' || cur.code === 'BHD' ? 1 : 0, minimumFractionDigits: 0 });
    } catch (e) {
      return;
    }

    // Where a rupee price appears, and whether to add "you pay in ₹ at checkout".
    var TARGETS = [
      ['.product__info-container [id^="price-"] .price', true],
      ['.card-information .price', false],
      ['.hod-plate__price strong', false],
      ['.hod-pay .totals__total-value', true],
    ];

    function figureIn(el) {
      if (!el.classList.contains('price')) return el;
      var onSale = el.classList.contains('price--on-sale');
      return el.querySelector(onSale ? '.price-item--sale' : '.price-item--regular') || el;
    }

    function apply() {
      TARGETS.forEach(function (t, i) {
        document.querySelectorAll(t[0]).forEach(function (el) {
          var src = figureIn(el);
          var inr = rupees(src);
          if (!inr) return;
          var line = el.parentNode && el.parentNode.querySelector(':scope > .hod-fx[data-for="' + i + '"]');
          var label = aboutText.replace('[amount]', fmt.format(inr * rate)) + (t[1] ? ' · ' + noteText : '');
          if (line) {
            if (line.textContent !== label) line.textContent = label;
            return;
          }
          line = document.createElement('small');
          line.className = 'hod-fx';
          line.setAttribute('data-for', String(i));
          line.textContent = label;
          el.insertAdjacentElement('afterend', line);
        });
      });
    }

    apply();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  detectCountry().then(function (country) {
    if (!country || country === 'IN' || allowed.indexOf(country) === -1) return;
    var cur = currencyFor(country);
    rateFor(cur).then(function (rate) {
      if (rate) start(cur, rate);
    });
  });
})();
